<template>
  <!-- 脚 -->
  <div id="foot">
    <div class="foot"></div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
#foot {
  background-color: #242b39;
margin-top: 10px;
  }

.foot {
  width: 1200px;
  height: 240px;
  margin: auto;
  border: 1px solid #ff6400;
}
</style>